import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/index.js';
import Header from '../../components/Header/Header.jsx';
import s from './Feeds.module.scss';

const fileName = (url) => {
  if (!url) return '';
  const name = url.split('/').pop();
  try {
    return decodeURIComponent(name);
  } catch {
    return name;
  }
};

const Feeds = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [title, setTitle] = useState('');
  const [bitrixUrl, setBitrixUrl] = useState('');

  const load = async () => {
    const data = await api.feeds.list();
    if (data.error) {
      setError(data.error);
      return;
    }
    setItems(data.items || []);
  };

  useEffect(() => {
    load();
  }, []);

  const create = async () => {
    const data = await api.feeds.create({ title, bitrix_url: bitrixUrl });
    if (data.error) {
      setError(data.error);
      return;
    }
    navigate(`/feeds/${data._id}`);
  };

  return (
    <>
      <Header
        title="Фиды"
        breadCrumbs={[
          { name: 'Главная', link: '/' },
          { name: 'Фиды', link: '/feeds' },
        ]}
      />
      <div className={s.wrap}>
        {error && <div className={s.error}>{error}</div>}
        <div className={s.grid}>
          {items.map((item) => (
            <div key={item._id} className={s.feedCard}>
              <h3 className={s.feedTitle}>{item.title}</h3>
              <div className={s.feedMeta}>
                <span className={s.feedFile}>{fileName(item.current_url) || 'Файла ещё нет'}</span>
                {item.current_url && (
                  <a className={s.feedLink} href={item.current_url} target="_blank" rel="noreferrer">
                    Открыть в S3
                  </a>
                )}
              </div>
              <button className="btn grey" onClick={() => navigate(`/feeds/${item._id}`)}>
                Настроить
              </button>
            </div>
          ))}
        </div>

        <section className={s.group}>
          <div className={s.groupHeader}>
            <h3 className={s.groupTitle}>Новый фид</h3>
          </div>
          <div className={s.groupBody}>
            <div className={s.form}>
              <label className={s.field}>
                <span className={s.label}>Название</span>
                <input className={s.input} value={title} onChange={(e) => setTitle(e.target.value)} />
              </label>
              <label className={s.field}>
                <span className={s.label}>Ссылка на выгрузку Битрикса</span>
                <input className={s.input} value={bitrixUrl} onChange={(e) => setBitrixUrl(e.target.value)} />
              </label>
              <button className="btn dark" disabled={!title || !bitrixUrl} onClick={create}>
                Создать
              </button>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Feeds;
